import styled from "styled-components";

export const StyledNav = styled.div`
  padding: 0.8rem;
  font-size: 1.6rem;
`;
